

















import {Component, Prop, Vue} from "vue-property-decorator";
import {range} from '@/app/util/range';

@Component
export default class Lives extends Vue {
    @Prop() total!: number;
    @Prop() selectable!: boolean;
    @Prop() value!: number;
    @Prop() disabled!: boolean;

    get range(): number[] {
        return range(1, this.total);
    }

    onStarClick(n: number): void {
        if (!this.selectable || this.disabled) {
            return;
        }

        this.$emit('input', n);
    }
}
